import { render } from "./WinnersView.vue?vue&type=template&id=7e80dbf3&scoped=true&ts=true"
import script from "./WinnersView.vue?vue&type=script&lang=ts"
export * from "./WinnersView.vue?vue&type=script&lang=ts"

import "./WinnersView.vue?vue&type=style&index=0&id=7e80dbf3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e80dbf3"]])

export default __exports__